import React, { useState } from 'react';
import { Form, Row, Col, Button } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

const initialShowNum = 6;

const AdvancedSearchForm = (props) => {
  // eslint-disable-next-line react/prop-types
  const { formData, extraButton, onSearch, onReset, loading } = props;
  const [expand, setExpand] = useState(false);
  const [showExpand, setShowExpand] = useState(false);
  const [form] = Form.useForm();
  const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };
  const getFields = () => {
    let haha = [];

    if (formData && formData.length) {
      // 输入表单的数量
      const totalLength = formData.length;
      // 长度大于默认显示数量，就显示 展开按钮
      if (totalLength > initialShowNum && !showExpand) {
        setShowExpand(true);
      }
      const count = expand ? formData.length : initialShowNum;

      // eslint-disable-next-line react/prop-types
      haha = formData.map(({ name, label, required, message, formItem }) => (
        <Col span={8} key={name}>
          <Form.Item
            name={name}
            label={label}
            labelWrap={true}
            rules={[
              {
                required: required || false,
                message: message || '请输入!',
              },
            ]}
          >
            {formItem}
          </Form.Item>
        </Col>
      ));
      // haha.splice(2,0,buttons);
      // haha = haha.slice(0,count+1)
      haha = haha.slice(0, count);
    }
    return haha;
  };

  const onFinish = (values) => {
    // console.log('请求: ', values);
    const cache = Object.fromEntries(
      Object.entries(values).filter((item) => item[1] !== ''),
    );
    onSearch(cache);
  };

  return (
    <Form
      form={form}
      name="advanced_search"
      className="ant-advanced-search-form"
      onFinish={onFinish}
      {...formItemLayout}
    >
      <Row gutter={24}>{getFields()}</Row>
      <Row>
        <Col
          span={24}
          style={{
            textAlign: 'right',
          }}
        >
          <Button loading={loading} type="primary" htmlType="submit">
            查询
          </Button>
          <Button
            style={{
              margin: '0 8px',
            }}
            onClick={() => {
              form.resetFields();
              onSearch({});
              // eslint-disable-next-line no-unused-expressions
              onReset && onReset();
            }}
          >
            重置
          </Button>
          {showExpand && (
            <a
              style={{
                fontSize: 12,
              }}
              onClick={() => {
                setExpand(!expand);
              }}
            >
              {expand ? <UpOutlined /> : <DownOutlined />}
              {expand ? '收起' : '展开'}
            </a>
          )}
          {extraButton && extraButton}
        </Col>
      </Row>
    </Form>
  );
};

export default AdvancedSearchForm;
